import { css } from '@emotion/core';
export var stickyBox = topEdgeOffset => /*#__PURE__*/css("position:sticky;top:", topEdgeOffset, "px;");